import {combineReducers} from "redux";
import achievementsReducer from './achievements'
import authReducer from './auth'

export default combineReducers({
    achievements: achievementsReducer,
    auth: authReducer
})